<template>
  <div
    class="window-item"
    :style="{ backgroundColor: $store.infoscreenData.infoboardBackgroundColor }"
  >
    <p
      class="window-id"
      :style="{
        color: $store.infoscreenData.infoboardWindowColor,
        fontFamily: `${$store.infoscreenData.fontBoldFamily}, ${$store.fontFamilyDefault}, sans-serif`
      }"
    >
      {{ ticket.prefix }}{{ ticket.number }}
    </p>
    <p
      class="orderNo"
      :style="{
        color: $store.infoscreenData.infoboardTicketNumberColor,
        fontFamily: `${$store.infoscreenData.fontBoldFamily}, ${$store.fontFamilyDefault}, sans-serif`
      }"
    >
      {{ orderNumber || ticketNumber }}
    </p>
    <p
      ref="windowNumber"
      class="window-id"
      :style="{
        color: $store.infoscreenData.infoboardWindowColor,
        fontFamily: `${$store.infoscreenData.fontBoldFamily}, ${$store.fontFamilyDefault}, sans-serif`
      }"
    >
      {{ WINDOW_TYPE_TRANSLATIONS[ticket.window.type] | translate }} {{ ticket.window.number }}
    </p>
  </div>
</template>

<script>
import TicketMixin from '../../mixins/TicketMixin';
import {WINDOW_TYPE_TRANSLATIONS} from '@/constants/WindowType';

export default {
  name: 'TicketInline',
  mixins: [TicketMixin],
  props: {
    ticket: {type: Object, default: () => ({window: {}})}
  },
  // TODO add proper param indication
  computed: {
    ticketNumber() {
      return `${this.ticket.prefix}${this.ticket.number}`;
    },
    orderNumber() {
      if (!this.ticket.additional_info) return undefined;

      const validInfo = Object.values(this.ticket.additional_info)[0];
      return validInfo ? validInfo.value : undefined;
    }
  },
  data() {
    return {
      defaultWindowNumberFontSize: 2.91666667,
      windowNumberFontSize: 2.91666667
    };
  },
};
</script>

<style lang="scss" scoped>
.window-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
  padding: 0 min(60px, 3.2vw);
}

.window-id {
  font-size: 2.91667vw;
  font-weight: 700;
}

.orderNo {
  font-size: 5vw;
  font-weight: 700;
}
</style>
